import {
  ColumnHeader,
  EarmarkDTO,
  EarmarkOptionDTO,
  OtherAssetType,
  OwnerOptionsDTO,
} from '../../OtherAssets.meta';

export const columnHeaders: ColumnHeader[] = [
  { text: 'Name' },
  { text: 'Owner' },
  { text: 'Value', align: 'right' },
  { text: 'Yearly Income', align: 'right' },
];

export interface BusinessSaleScheduleDTO {
  YearsAfterSaleYear: number;
  SaleAmount: number | null;
  NetWorthPercent: number | null;
}

export interface BusinessAssetDTO {
  Id: string;
  Name: string;
  Value: number | null;
  Owner: string;
  YearlyIncome: number | null;
  SaleYear: number | null;
  BusinessSaleSchedule: BusinessSaleScheduleDTO[];
  IsSoldAtRetirement: boolean | null;
  SaleNetEarnings: number | null;
  IncomeGrowth: number | null;
  SelfEmployed: boolean | null;
  AssetEarmark: EarmarkDTO[];
  AssetGrowth: number;
  OtherAssetType: OtherAssetType;
  CustomBucketIndex: number | null;
  IsExcludedFromAssetBucketing: boolean;
  IsLiquid: boolean;
  IncludeInGrossEstate: boolean;
  OrionManagementStyleId: number | null;
}

export interface BusinessAssetOptionsDTO {
  ownerOptions: OwnerOptionsDTO;
  SaleYearOptions: string[];
  EarmarkOptions: EarmarkOptionDTO[];
  DefaultAssetBucketIndex: number | null;
  IsLiquid: boolean;
}
